/* eslint-disable */
export const user= {
    id    : 'cfaad35d-07a3-4447-a6c3-d8c3d54fd5df',
    name  : 'Rodolfo Alvarez Marín',
    email : 'ralvarez@softram.cl',
    avatar: 'assets/images/avatars/ralvarez-softram-cl.jpg',
    status: 'online',
};
